var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.modalAction
    ? _c(
        "b-modal",
        {
          attrs: {
            id: "multipleConfirmModal",
            title: _vm.modalAction.Title,
            "hide-footer": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("h6", { staticClass: "my-4" }, [
                      _vm._v(_vm._s(_vm.modalAction.QueryMessage))
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("ModalElements", {
            attrs: {
              actionUrl: _vm.modalAction.ActionUrl,
              recordId: _vm.recordIds
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e84bfec2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e84bfec2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Actions/MultipleConfirmModal.vue
// module id = null
// module chunks = 